import { LocalPersistence } from '../../factories/index'

const isAdminUser = async () => {
  /**
   * availaible roles
   * Super Admin
   * Account Admin
   * User
   * Internal User
   */
  try {
    // get session data
    const get_session = new LocalPersistence('session')
    const session: { role: string } = await get_session.getSessionPersistence()
    // validates is not null or empty
    // converting to lower case for case sentitive use cases
    // validates includes Admin
    return !!session.role && session.role.toLowerCase().includes('admin')
  } catch (error: any) {
    return error
  }
}

const isSuperAdminUser = async () => {
  try {
    // get session data
    const get_session = new LocalPersistence('session')
    const session: { role: string } = await get_session.getSessionPersistence()
    // validates is not null or empty
    // converting to lower case for case sentitive use cases
    // validates includes Super Admin
    return !!session.role && session.role.toLowerCase() === ('super admin')
  } catch (error: any) {
    return error
  }
}

// getting the session data
const getSession = async () => {
  const get_session = new LocalPersistence('session')
  const session = await get_session.getSessionPersistence()
  return session
}


const getSupplier = (chains: any[])=> {
  let supplier
  if (chains[0].chainName) {
    supplier = chains[0].chainName
  } else {
    supplier = chains[0]
  }
  return supplier;
}


export {
  isAdminUser,
  isSuperAdminUser,
  getSession,
  getSupplier
}
